import type { MaybeRef } from "vue"
import type { ServerResponse } from "@/http"
import type { IEventUpgradesResponse } from "@/models"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { axios } from "@/axios"
import { EventUpgradePackage } from "@/models"

export async function listEventUpgrades(eventVaultID: number) {
  const response = await axios.get<ServerResponse<IEventUpgradesResponse[]>>(`api/event/${eventVaultID}/upgrades`)

  return response.data.Data?.map(upgrade => EventUpgradePackage.fromResponse(upgrade)) ?? []
}

export function useListEventUpgrades(eventVaultId?: MaybeRef<number>) {
  return useQuery({
    queryKey: ["listEventUpgrades", eventVaultId],
    queryFn: () => listEventUpgrades(toValue(eventVaultId)!),
    enabled: !!toValue(eventVaultId),
  })
}
